import * as v from "valibot";
import { BaseRecordSchema, baseVals, defineValidation } from "../../common/validation.common";

export namespace HotspotTemplateValidation {
    export const Record = defineValidation(BaseRecordSchema);

    export const Create = defineValidation(
        v.object({
            name: baseVals.string(),
            template: v.object({
                code: baseVals.string(),
                width: v.number(),
                height: v.number(),
            }),
        }),
    );

    export const Update = defineValidation(
        v.object({
            name: v.exactOptional(baseVals.string()),
            template: v.exactOptional(
                v.object({
                    code: baseVals.string(),
                    width: v.number(),
                    height: v.number(),
                }),
            ),
        }),
    );
}
